<div class="early-access-label {{ featureType }}">{{ featureType | capitalize }}</div>
